export interface LeaseTransaction {
  id?: string;
  source?: TransactionSource;
  type: TransactionType;
  transactionDate: string;
  chartOfAccountId?: string;
  description?: string;
  amount: number;
  billAmountRemaining?: number;
  failed?: boolean;
  status?: LeaseTransactionStatus;
  currentBalance: number;
  postedBalance: number;
  chartOfAccount?: ChartOfAccountDto;
}

export enum TransactionSource {
  Bill = 'bill',
  Transaction = 'transaction',
}

export enum TransactionType {
  Payment = 'payment',
  Charge = 'charge',
  LeaseCredit = 'leaseCredit',
  Return = 'return',
  Unknown = 'unknown',
}

export enum LeaseTransactionStatus {
  Future = 'future',
  Due = 'due',
  PastDue = 'pastDue',
  Paid = 'paid',
  Failed = 'failed',
  Returned = 'returned',
  Processing = 'processing',
  Settled = 'settled',
  Disputing = 'disputing',
}

export interface ChartOfAccountDto {
  id?: string;
  name?: string;
  type?: ChartOfAccountType;
  isDefault?: boolean;
}

export enum ChartOfAccountType {
  Asset = 'asset',
  Equity = 'equity',
  Liability = 'liability',
  RevenueExpense = 'revenueExpense',
}

export interface TransactionSummary {
  currentBalance: number;
  postedBalance: number;
  transactions: LeaseTransaction[];
}
